import { makeAutoObservable } from "mobx";
import { RtStore } from "src/components/ReactiveTable/RtStore";

import {
  createNewDemoData,
  deleteDemoData,
  demoDataLoader,
  loadDemoConfig,
  saveDemoConfig,
} from "./data/demoDataAccess";
import { DemoFilters, ZDemoData } from "./data/demoDataTypes";

type TDMode = "deleteAll" | "generate";

export const tableDemoPageStore = makeAutoObservable({
  tableStore: new RtStore<ZDemoData, DemoFilters>({
    rowKey: "id",
    loader: demoDataLoader,
    defaultRequest: {
      pageSize: 10,
      sortOrder: [{ columnKey: "name", mode: "ascend" }],
    },
    configAccess: {
      load: loadDemoConfig,
      save: saveDemoConfig,
    },
    // sortClickHandler: multiSortClickHandler, // Пока нет требований к сортировке по нескольким столбцам
    // fixedLeftRaw: 1,
  }),
  mode: null as TDMode | null,
  setMode(newMode: TDMode | null) {
    this.mode = newMode;
  },
  get buzy(): boolean {
    return this.tableStore.loading;
  },
  isDisabled(taskMode?: TDMode): boolean {
    return this.buzy && (!taskMode || taskMode !== this.mode);
  },
  async updateTask(taskMode: TDMode, task: () => Promise<void>) {
    const { tableStore } = this;
    try {
      this.setMode(taskMode);
      tableStore.lock();
      await task();
      tableStore.reload().catch(tableStore.onError);
    } finally {
      tableStore.unlock();
      this.setMode(null);
    }
  },
  async generate() {
    await this.updateTask("generate", () => createNewDemoData(200));
  },
  reload() {
    this.tableStore.update({ page: 0 });
  },
  async deleteAll() {
    await this.updateTask("deleteAll", deleteDemoData);
  },
  selectionOptions: [
    { value: "", label: "Нет выбора" },
    { value: "radio", label: "Единичный" },
    { value: "checkbox", label: "Множественный" },
  ],
});
